// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"92825930","967":"88c7d2ac"}[chunkId] + ".chunk.js";
};